import PromptModal from './PromptModal';
import PromptModalSimple from './PromptModalSimple';
import PageCard from './PageCard';
import VideoPageCard from './VideoPageCard';
import MultiplePageCard from './MultiplePageCard';
import aigcIcon from './styles/aigc.svg';
import GptButton from './components/GptButton';
import {
  GPTOptionsForm,
  GPTOptions,
} from './PromptModal/PromptForm/GPTOptionsForm';
import {
  AgentOptions,
  AgentOptionsForm,
} from './PromptModal/PromptForm/AgentOptions';
import StatusTips from './components/StatusTips';
import ResultOutputForm from './PromptModal/PromptForm/ResultOutputForm';
import { GPTSummaryNameForm } from './PromptModal/PromptForm/GPTSummaryName';
import GPTAutoReportForm from './PromptModal/PromptForm/GPTAutoReportForm';
import AnalysisTarget from './PromptModal/PromptForm/AnalysisTarget';
import CommonForm from './PromptModal/PromptForm/CommonForm';
import HistoricalPrompt from './components/HistoricalPrompt';
import { GPTSummaryMultiNameForm } from './PromptModal/PromptForm/GPTSummaryMultiName';
import SteamingPageCard from './SteamingPageCard';
export * from './PromptList';

/**
 * TODO: 其他系统使用
 * GPT组件
 */
export default {
  PromptModalSimple,
  PromptModal,
  PageCard,
  VideoPageCard,
  SteamingPageCard,
  MultiplePageCard,
  icon: aigcIcon,
  Button: GptButton,
  GPTOptionsForm,
  GPTOptions,
  AgentOptions,
  AgentOptionsForm,
  StatusTips,
  ResultOutputForm,
  GPTSummaryNameForm,
  GPTAutoReportForm,
  AnalysisTarget,
  CommonForm,
  HistoricalPrompt,
  GPTSummaryMultiNameForm
};
